import { useState } from 'react';
import SectionHeading from '@/pages/home/components/SectionHeading';
import { episodes } from '@/mocks/home';

export default function EpisodesSection() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  const toggle = (index: number) => {
    setOpenIndex((prev) => (prev === index ? -1 : index));
  };

  return (
    <section id="episodes" className="bg-background-50 px-4 py-16 md:px-8 md:py-24">
      <div className="mx-auto w-full max-w-4xl">
        <SectionHeading
          eyebrow="分集看点"
          title="八集看点速览：每一集在埋什么"
          desc="点开任意一集，查看该集的信息重点与叙事手法。适合追剧前预习，也适合看完后回头对照。"
          align="center"
        />

        <div className="mt-10 space-y-3 md:mt-14">
          {episodes.map((episode, index) => {
            const isOpen = openIndex === index;
            return (
              <div
                key={episode.no}
                className={`reveal overflow-hidden rounded-lg border bg-background-100 transition-colors ${
                  isOpen ? 'border-primary-300' : 'border-background-200'
                }`}
              >
                <h3>
                  <button
                    type="button"
                    onClick={() => toggle(index)}
                    aria-expanded={isOpen}
                    className="flex w-full items-center gap-4 px-5 py-4 text-left transition-colors hover:bg-background-200/50 md:px-6 md:py-5"
                  >
                    <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-primary-500 font-heading text-sm font-bold text-background-50">
                      {index + 1}
                    </span>
                    <span className="flex-1">
                      <span className="block text-xs font-medium text-primary-600">
                        {episode.no}
                      </span>
                      <span className="mt-0.5 block font-heading text-sm font-semibold text-foreground-950 md:text-base">
                        {episode.title}
                      </span>
                    </span>
                    <i
                      className={`ri-arrow-down-s-line shrink-0 text-xl text-foreground-500 transition-transform duration-300 ${
                        isOpen ? 'rotate-180' : ''
                      }`}
                      aria-hidden="true"
                    ></i>
                  </button>
                </h3>

                <div
                  className={`grid transition-all duration-300 ease-out ${
                    isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'
                  }`}
                >
                  <div className="overflow-hidden">
                    <div className="border-t border-background-200 px-5 pb-5 pt-4 md:px-6">
                      <p className="text-sm leading-7 text-foreground-700 md:leading-8">
                        {episode.summary}
                      </p>
                      <ul className="mt-4 space-y-2">
                        {episode.points.map((point) => (
                          <li key={point} className="flex items-start gap-2.5">
                            <i
                              className="ri-checkbox-circle-line mt-0.5 shrink-0 text-base text-accent-600"
                              aria-hidden="true"
                            ></i>
                            <span className="text-sm leading-7 text-foreground-600">{point}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}